import { render } from "./InterestsComponent.vue?vue&type=template&id=456da20b&ts=true"
import script from "./InterestsComponent.vue?vue&type=script&lang=ts"
export * from "./InterestsComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__